// IpesQuery.ts
import gql from "graphql-tag";

export default gql`
  query Ipes(
    $issuerCnpj: String
    $deliveryDateStart: Date!
    $deliveryDateEnd: Date!
    $limit: Int
    $cursor: Cursor
    $filterByCategories: [String!]
    $filterByHasSubjects: Boolean
  ) {
    ipes(
      issuerCnpj: $issuerCnpj
      deliveryDateStart: $deliveryDateStart
      deliveryDateEnd: $deliveryDateEnd
      limit: $limit
      cursor: $cursor
      filterByCategories: $filterByCategories
      filterByHasSubjects: $filterByHasSubjects
    ) {
      nodes {
        sequentialId
        protocol
        category
        type
        kind
        subjects
        dateOfReference
        deliveryDate
        url
        downloadUrl
        issuer {
          _id
          name
          tickerSymbolPrefix
          standardLogo {
            url
          }
          niceLogo {
            url
          }
        }
      }
      totalCount
      pageInfo {
        cursor
        hasNextPage
      }
    }
  }
`;
